module.exports = __webpack_public_path__ + "media/images/icons/map/marker-end-point-f7477ebb28867f7bd8f79f6735fb8de0.png";